module.exports = __webpack_public_path__ + "img/3.710ebbec.webp";